<script setup lang="ts">
/**
 * Final Dividends — Notice of Extraordinary General Meeting (Multiple / Sole Individual).
 *   원본: Notice of EGM – Final Dividends (Multiple Members / Sole Individual Member).
 *   서명 = By Order Of The Board, 이사 1인([[Signing_Director_Signature]]) → signing_director_Signers.
 */
import { inject, ref } from 'vue';
import CddVarField from '../cdd/CddVarField.vue';
import AgmSigners from '../cdd/AgmSigners.vue';
import { DIV_SCENARIO, type DivScenario } from './scenario';
import './agmDoc.css';

const scenario = inject(DIV_SCENARIO, ref<DivScenario>('multiple'));
const isMulti = () => scenario.value === 'multiple';
</script>

<template>
  <div class="agm-doc">
    <div class="doc-head">
      <div><b><CddVarField field-key="company_name" label="Company Name" /></b></div>
      <div>Company Registration No. <CddVarField field-key="company_registration_no" label="Reg No" /></div>
      <div>(Incorporated in the Republic of Singapore)</div>
      <div>(the &ldquo;Company&rdquo;)</div>
      <div>Registered Office: <CddVarField field-key="registered_office_address" label="Registered Office Address" /></div>
    </div>

    <div class="doc-title">NOTICE OF EXTRAORDINARY GENERAL MEETING</div>
    <p class="doc-p">NOTICE IS HEREBY GIVEN that the Extraordinary General Meeting of the Company will be held at:</p>

    <table class="cdd-tbl">
      <tbody>
        <tr><td class="cdd-lcell">Venue</td><td><CddVarField field-key="meeting_venue" label="Meeting Venue" /></td></tr>
        <tr><td class="cdd-lcell">Date</td><td><CddVarField field-key="meeting_date" label="Meeting Date" /></td></tr>
        <tr><td class="cdd-lcell">Time</td><td><CddVarField field-key="meeting_time" label="Meeting Time" /></td></tr>
      </tbody>
    </table>

    <p class="doc-p">to transact the following business:</p>
    <div class="sec-title">AGENDA</div>
    <p class="doc-p">To consider, and if thought fit, to pass the following ordinary resolution{{ isMulti() ? '' : 's' }}:</p>

    <div class="sec-title" style="text-align:center">&ldquo;FINAL DIVIDEND</div>
    <p class="doc-p">
      NOTED THAT the Company has sufficient profits for the declaration of a final dividend of
      <CddVarField field-key="dividend_amount" label="Dividend Amount" /> to its {{ isMulti() ? 'members' : 'member' }}.
    </p>
    <p class="doc-p">
      RESOLVED THAT a final one-tier tax exempt dividend of <CddVarField field-key="dividend_amount" label="Dividend Amount" />
      in respect of the financial year ended <CddVarField field-key="financial_year_end" label="Financial Year End" />
      be recommended for payment out of the profits of the Company to the {{ isMulti() ? 'members' : 'member' }}
      whose names appear on the Register of Members.&rdquo;
    </p>

    <p class="doc-p">By Order Of The Board</p>
    <div class="sign-block">
      <AgmSigners var-key="signing_director_Signers" board-label="Director" />
    </div>
    <p class="doc-p">Date: <CddVarField field-key="notice_date" label="Notice Date" /></p>

    <p class="doc-note">
      Notes:<br />
      A member entitled to attend and vote at the above meeting is entitled to appoint a proxy to attend and vote instead of him.
      A proxy need not be a member of the Company.<br />
      A corporation which is a member of the Company may, by resolution of its directors, authorise any person to act as its
      representative at any meetings of the Company, and such representative shall be entitled to exercise the same powers on behalf
      of the corporation which he represents as if he had been an individual member of the Company.<br />
      The instrument appointing a proxy must be deposited at the registered office of the Company not less than 48 hours before the meeting.
    </p>
  </div>
</template>
